import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=7e748c68&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=ts"
export * from "./ChatRoom.vue?vue&type=script&lang=ts"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=7e748c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e748c68",
  null
  
)

export default component.exports